function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 5.9999,6.00002 -4.35,-4.35",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  id: "path833"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m 9,17 c 4.4183,0 8,-3.5817 8,-8 C 17,4.58172 13.4183,1 9,1 4.58172,1 1,4.58172 1,9 c 0,4.4183 3.58172,8 8,8 z",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  id: "path846"
});

var SvgMagnifierSearch = function SvgMagnifierSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.3213568mm",
    height: "5.3213587mm",
    viewBox: "0 0 5.3213568 5.3213587",
    id: "svg8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-102.61875,-146.11875)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g844",
    transform: "matrix(0.26458333,0,0,0.26458333,106.08805,149.58802)"
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g857",
    transform: "matrix(0.26458333,0,0,0.26458333,102.61875,146.11875)"
  }, _ref4)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagnifierSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifier_search.fc036f3f.svg";
export { ForwardRef as ReactComponent };